<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <h2>用户登录</h2>
        <!-- <p>请选择登录方式</p> -->
      </div>

      <!-- 账号密码登录表单 -->
      <div class="login-form">
        <div class="form-group">
          <label>账号</label>
          <input type="text" v-model="form.username" placeholder="请输入账号" class="input-large" />
        </div>
        <div class="form-group">
          <label>密码</label>
          <input type="password" v-model="form.password" placeholder="请输入密码" class="input-large" />
        </div>
        <button class="login-btn" @click="loginByAccount">登录</button>
      </div>

      <!-- 登录方式切换 -->
      <div class="login-tabs">
        <!-- 手机号登录时显示微信登录切换按钮 -->
        <div 
          v-if="loginType === 'phone'"
          class="tab-item" 
          @click="switchLoginType('wechat')"
        >
          <i class="wechat-icon">💬</i>
          微信登录
        </div>
        <!-- 微信登录时显示手机号登录切换按钮 -->
        <div 
          v-if="loginType === 'wechat'"
          class="tab-item" 
          @click="switchLoginType('phone')"
        >
          <i class="phone-icon">📱</i>
          手机号登录
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'UserLogin',
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      loading: false,
      city: '',
      loginTime: ''
    }
  },
  created() {
    this.getCityByIp();
    this.setLoginTime();
  },
  methods: {
    async getCityByIp() {
      try {
        const res = await fetch('http://ip-api.com/json/?lang=zh-CN');
        const data = await res.json();
        this.city = data.city || data.regionName || data.country || '未知';
      } catch (e) {
        this.city = '未知';
      }
    },
    setLoginTime() {
      const now = new Date();
      const pad = n => n < 10 ? '0' + n : n;
      this.loginTime = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    },
    async loginByAccount() {
      if (!this.form.username || !this.form.password) {
        alert('请输入账号和密码');
        return;
      }
      this.loading = true;
      this.setLoginTime();
      try {
        const res = await axios.post('/api/customers/login', {
          user: this.form.username,
          password: this.form.password,
          city: this.city,
          time: this.loginTime
        });
        if (res.data && res.data.success) {
          const info = res.data.data;
          // 设置客户认证信息
          localStorage.setItem('username', info.customer || info.user);
          localStorage.setItem('userRole', 'customer');
          localStorage.setItem('customerInfo', JSON.stringify(info));
          console.log('登录成功！');
          
          // 直接跳转到客户信息页面
          this.$router.push('/app/information');
        } else {
          alert('账号或者密码错误，请重新输入');
        }
      } catch (e) {
        alert('登录失败，请检查网络或稍后重试');
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.login-card {
  background: white;
  border-radius: 18px;
  box-shadow: 0 8px 32px rgba(76, 110, 245, 0.12);
  padding: 48px 40px 36px 40px;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.login-header {
  text-align: center;
  margin-bottom: 36px;
}

.login-header h2 {
  color: #333;
  margin: 0 0 10px 0;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 1px;
}

.login-header p {
  color: #888;
  margin: 0;
  font-size: 15px;
}

.login-tabs {
  display: flex;
  margin: 30px 0 20px 0;
  border-radius: 12px;
  overflow: hidden;
  background: #f8f9fa;
  padding: 4px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  justify-content: center;
  display: none;
}

.tab-item {
  padding: 14px 24px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: transparent;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  position: relative;
  z-index: 1;
  min-width: 120px;
}

.tab-item:hover {
  background: rgba(66, 185, 131, 0.1);
  color: #42b983;
  transform: translateY(-1px);
}

.tab-item:active {
  transform: translateY(0);
}

.tab-item i {
  margin-right: 6px;
  font-size: 16px;
}

/* 登录方式切换样式 */
.login-method-tabs {
  display: flex;
  margin-bottom: 20px;
  border-radius: 12px;
  overflow: hidden;
  background: #f8f9fa;
  padding: 4px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
}

.method-tab {
  flex: 1;
  padding: 12px 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  color: #666;
  border-radius: 8px;
  position: relative;
  z-index: 1;
}

.method-tab.active {
  background: linear-gradient(135deg, #42b983 0%, #3aa876 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(66, 185, 131, 0.3);
  transform: translateY(-1px);
}

.method-tab:hover:not(.active) {
  background: rgba(66, 185, 131, 0.1);
  color: #42b983;
  transform: translateY(-1px);
}

.method-tab:active {
  transform: translateY(0);
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  color: #444;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 2px;
}

.input-large {
  width: 90%;
  padding: 14px 16px;
  border: 1.5px solid #e0e3eb;
  border-radius: 10px;
  font-size: 16px;
  background: #f8fafd;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.04);
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
}
.input-large:focus {
  border-color: #667eea;
  background: #fff;
  box-shadow: 0 0 0 2px #a5b4fc44;
}

.code-input-group {
  display: flex;
  gap: 10px;
}

.code-input-group input {
  flex: 1;
}

.send-code-btn {
  padding: 12px 16px;
  background: linear-gradient(135deg, #42b983 0%, #3aa876 100%);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(66, 185, 131, 0.2);
  min-width: 100px;
}

.send-code-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #3aa876 0%, #2d8f5f 100%);
  box-shadow: 0 4px 8px rgba(66, 185, 131, 0.3);
  transform: translateY(-1px);
}

.send-code-btn:active:not(:disabled) {
  transform: translateY(0);
}

.send-code-btn:disabled {
  background: linear-gradient(135deg, #ccc 0%, #bbb 100%);
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  margin-right: 8px;
  width: auto;
}

.forgot-link {
  color: #42b983;
  text-decoration: none;
  font-size: 14px;
}

.forgot-link:hover {
  text-decoration: underline;
}

.login-btn {
  width: 100%;
  padding: 16px;
  background: linear-gradient(90deg, #667eea 0%, #42b983 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.10);
  margin-top: 10px;
  letter-spacing: 1px;
}
.login-btn:hover {
  background: linear-gradient(90deg, #42b983 0%, #667eea 100%);
  box-shadow: 0 8px 24px rgba(66, 185, 131, 0.13);
}

.login-btn:active {
  transform: translateY(0);
}

.wechat-login {
  text-align: center;
}

.wechat-qr-container {
  margin-bottom: 30px;
}

.qr-code {
  width: 200px;
  height: 200px;
  margin: 0 auto 20px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-placeholder {
  text-align: center;
  color: #666;
}

.qr-icon {
  font-size: 48px;
  margin-bottom: 10px;
  display: block;
}

.qr-tip {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.wechat-options {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.wechat-btn,
.refresh-btn {
  padding: 10px 20px;
  border: 1px solid #42b983;
  border-radius: 6px;
  background: white;
  color: #42b983;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.wechat-btn:hover,
.refresh-btn:hover {
  background: #42b983;
  color: white;
}
</style>
